import { ImageFileTypes } from '@app/enums/image-file-types.enum';

export function getImageFileTypes(): string[] {
    return Object.keys(ImageFileTypes).map((fileType) => ImageFileTypes[fileType]);
}
